module.exports = __webpack_public_path__ + "static/media/AdditionsItemCalloutsExample@3x.fc190af67ff5d724cd027291424606c7.jpg";